import { render, staticRenderFns } from "./Fact.vue?vue&type=template&id=d32605e0"
import script from "./Fact.vue?vue&type=script&lang=ts"
export * from "./Fact.vue?vue&type=script&lang=ts"
import style0 from "./Fact.vue?vue&type=style&index=0&id=d32605e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports